import { render, staticRenderFns } from "./goodsDetailDialog.vue?vue&type=template&id=62f6fe5a&scoped=true"
import script from "./goodsDetailDialog.vue?vue&type=script&lang=js"
export * from "./goodsDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailDialog.vue?vue&type=style&index=0&id=62f6fe5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6fe5a",
  null
  
)

export default component.exports